const cardDatas = [
  {
    id: 1,
    title: "Business",
    description: "SUN, OCT 24 @ 1:15 AM ICT",
    description1: "How to make your business growth 10 times within 1 year",
    description2: "By Adit nento",
    img: "https://s3-alpha-sig.figma.com/img/9568/ceda/08c92da8d94729fd2bf373c902589f2d?Expires=1637539200&Signature=G7qVp~cNpxlKX0e3dAH3DaaY7Fob3gEvmKTWcqQ0nCklBdZCLq-j1P433GV4djH7vUyPUCmh0Ti-Sdpw~S5FC3lsyPcVYyEJkR-5WeN5otC2mFC06qPglDMll~7iBDhS07bn~RNay4nufUvUyqlPE8-kxhBaCuNWGwkD13k1HGNjK5NJ1Dcm968Im6xvpDKqZrTPj6uns-YYP41VOfXVKrF7T6TVZhuSXxV3TVDrdIQSNX-39KYyoyajgAKgpU4q9ZUDiOHGxGaMOVSQI40NIbG78orQ6Jovn41WN5OAm9uqXAyhTQPOmvLR1AuteuhxNmwQ75FOhxaOhtQTeWsMpw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
  {
    id: 2,
    title: "Design",
    description: "SUN, OCT 24 @ 1:15 AM ICT",
    description1: "Hitting Reset: How to ladn A Job in UX Design",
    description2: "By Ernest",
    img: "https://s3-alpha-sig.figma.com/img/02d1/31cd/97a20b34d4c259133af7a6300eeaea07?Expires=1637539200&Signature=XDKQQT-TMFKmEnYdzu3xWXKOmCmW1GodnJ~GDz~ssqz2icrawj5vBxUFDxWD3hFTuCrRwmvGBbFWYPKZa9azVMpDExwiA7eticijx-Ra2K41W1t28leOjhqFz44dxHhjT~eNw5bBAu3KOFConlud7ieQenPBL3~N7Hk2qq-zwVQkirxr5eu8Fcl7bm~w4N9LjVAnEata2OjOwWzACcC5aOz5T-Si4IMMRNkJs-aaEpTMRS-MNDvk1mYpwq3tb7Jiu--S4EnJuFVQIxNARnmIcUTWm66L5ugWkBUVqMwDMVLdSXsn73ZGwt2Endp6-3nfRAef5Uo0EC9KEMspEtWCHg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
  {
    id: 3,
    title: "Marketing",
    description: "SUN, OCT 24 @ 1:15 AM ICT",
    description1: "Google Ads 101 with the best marketing agency",
    description2: "By budi Setiawan",
    img: "https://s3-alpha-sig.figma.com/img/ba7c/4f70/c12a349ad9b3edc4112fe0e250c81703?Expires=1637539200&Signature=DVefkaBv~6BmSF5mq~15nTikwzO0fyV7bCIr7-fP8kuEHpwkapqhy~P4cqIQ1i03Tav3dO~zC9bDM31JKMPqoutspkumiqD6wOsgiAX4aCt7nmu9PYxwuxQfqq5fZjsahyVNJiI6YQKLo46s-zEjvAaq3R96fqPVkBA25JUNuW6l~nAnbZCQ2C6wMZCRNuUZe4fBCr0USzoiCXvm3zZHIjstGk7LhgBeI2JdPpeinOS0RNj4Ue35v-dWufTc1vs8Ia9AqXzTHl6x68px8yE5j9YQzNY9R2jLiIr94YdiafU6RLv~QkvfQnSeRBNNelkvOlEQCHdTO2hSjPoPb4GofA__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
  {
    id: 4,
    title: "Design",
    description: "SUN, OCT 24 @ 1:15 AM ICT",
    description1: "How to create a design system",
    description2: "By Agung Dwi Putra",
    img: "https://s3-alpha-sig.figma.com/img/788d/47f4/503780411503b39c7c618d4fdc640178?Expires=1637539200&Signature=EDc67-aCI4g0tzFTQ1NxzuzrG2ukAeBVWwnORLFBG8Tk3iER3qb6bL9lg-mgpqztllIM7X9PNRzXnEPH6x7DR6bmTGpkS47ew8Huz1UG~VhxNFIJPOr48FVJV08J-I-LtMuB8atI~oanWlEMQsvRpSZQ5nfI1HEUQEHhY2GPbL2noU4GYEMEDUSnrWIXDLPlroSNhymTXMQBtY-s2a~qlnKeDrJa1DWU5j8xVeydOFtFw~UnWlWkXqweTQmlpmqxY49GPBkkEP07KWzwntNHV7evdUTh0St5hCPbInCKIr7MWa2ecPIiN1Fd~it-U37DtF~OJ~PekhvCPp0zV0MZPg__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA",
  },
];
export default cardDatas;
